module.exports = __webpack_public_path__ + "static/media/titleWithCaption.251fedcb.png";